type Props = {
  onClick?: () => void;
  children: JSX.Element;
};
const ClickableContainer = ({ children, onClick }: Props) => {
  return (
    <span className="clickable-icon" onClick={onClick}>
      {children}
    </span>
  );
};

export default ClickableContainer;
